import styled from 'styled-components';

export const Description = styled.div`
	padding: 0.5rem 1rem;
	font-weight: 600;
	text-align: center;
`;
